import FileSaver from 'file-saver';

function parseBlob(response) {
    return response.blob();
}

export default function download(file) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = file.name,
        link = file.link;


    fetch(link, { 'method': 'GET', headers: headers }).then(parseBlob).then(function (blob) {
        return FileSaver.saveAs(blob, name);
    }).catch(function (e) {
        return console.error(e);
    });
}